import { fetchLanguages, fetchGroups, fetchTranslationsByGroup, fetchTranslationsIdentifiersByGroup } from '../repositories/language.repository'

const state = {
    languages: [],
    groups: [],
    groupTranslations: [],
    groupIdentifiers: []
}

const actions = {
    fetchLanguages ({ commit }) {
        return new Promise(resolve => fetchLanguages()
            .then(res => {
                commit('setLanguages', res.data)
                resolve()
            })
            .catch(error => console.log(error)))
    },
    fetchGroups ({ commit }) {
        return new Promise(resolve => fetchGroups()
            .then(res => {
                commit('setGroups', res.data)
                resolve()
            })
            .catch(error => console.log(error)))
    },
    fetchTranslationsByGroup ({ commit }, groupId) {
        return new Promise(resolve => fetchTranslationsByGroup(groupId)
            .then(res => {
                commit('setGroupTranslations', res.data)
                resolve()
            })
            .catch(error => console.log(error)))
    },
    fetchTranslationsIdentifiersByGroup ({ commit }, groupId) {
        return new Promise(resolve => fetchTranslationsIdentifiersByGroup(groupId)
            .then(res => {
                commit('setGroupIdentifiers', res.data)
                resolve()
            })
            .catch(error => console.log(error)))
    }
}

const mutations = {
    setLanguages (state, languages) {
        state.languages = languages
    },
    setGroups (state, groups) {
        state.groups = groups
    },
    setGroupTranslations (state, translations) {
        state.groupTranslations = translations
    },
    setGroupIdentifiers (state, identifiers) {
        state.groupIdentifiers = identifiers
    }
}

export default {
    state,
    actions,
    mutations
}